import { API_ENDPOINT } from './index';

export const PROVIDER_ASSIGNMENTS_BASE_URL = `${API_ENDPOINT}/provider_assignments`;
